import { Component, input } from '@angular/core';
import { UsdDisplayComponent } from 'app/driver-pay/persistence/core/components/displays/UsdDisplay.component';
import { DisplayComponent } from './DisplayComponent';

@Component({
  selector: 'usd-display-blank-if-zero',
  standalone: true,
  imports: [UsdDisplayComponent],
  template: `
    @if (isZero()) {
      <span>&nbsp;</span>
    } @else if (isString()) {
      <span [id]="id()">{{ value() }}</span>
    } @else {
      <usd-display [id]="id()" [value]="value()" />
    }
  `,
})
export class UsdDisplayBlankIfZeroComponent implements DisplayComponent {
  id = input<string | undefined>();
  value = input.required<object | undefined>();

  isString(): boolean {
    const val = this.value();
    return typeof val === 'string' && Number.isNaN(Number(val));
  }

  isZero(): boolean {
    const val = this.value();
    if (val === undefined || val === null) {
      return false;
    }

    const num = Number(val);
    return !Number.isNaN(num) && num === 0;
  }
}
